import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { StockReturnRequestProvider } from '../partner/stockReturnRequest/ContextAPI';
import Index from '../partner/stockReturnRequest/Index';
import PermissionDenied from './PermissionDenied';

export default function StockReturnRequestPartner() {
    // Route Permission
    const { auth } = useAuth();
    const { route_permissions } = auth;
    if (!route_permissions['stock-return-request-partner']) return <PermissionDenied />;

    return (
        <StockReturnRequestProvider>
            <Index />
        </StockReturnRequestProvider>
    );
}
